import script from "./Committees.vue?vue&type=script&setup=true&lang=js"
export * from "./Committees.vue?vue&type=script&setup=true&lang=js"

import "./Committees.vue?vue&type=style&index=0&id=b6a4dd02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6a4dd02"]])

export default __exports__